/** Naslovi i kratki opisi za kartice putovanja (lista, popup, ulazni banner). */

const TOUR_TITLES = {
  barcelona: {
    hr: "Barcelona & Costa Brava",
    en: "Barcelona & Costa Brava",
    de: "Barcelona & Costa Brava",
    es: "Barcelona y Costa Brava",
  },
  mexico: {
    hr: "Meksički kolonijalni gradovi i Karibi",
    en: "Mexican colonial cities & Caribbean",
    de: "Mexikanische Kolonialstädte & Karibik",
    es: "Ciudades coloniales y Caribe mexicano",
  },
  tuscany: {
    hr: "Toskana i Cinque Terre",
    en: "Tuscany & Cinque Terre",
    de: "Toskana & Cinque Terre",
    es: "Toscana y Cinque Terre",
  },
  alicante: {
    hr: "Alicante – Escapada de Primavera",
    en: "Alicante – Spring Escape",
    de: "Alicante – Frühlingsausflug",
    es: "Alicante – Escapada de Primavera",
  },
  "alicante-maj": {
    hr: "Alicante – Escapada de Primavera (svibanj)",
    en: "Alicante – Spring Escape (May)",
    de: "Alicante – Frühlingsausflug (Mai)",
    es: "Alicante – Escapada de Primavera (mayo)",
  },
  "alicante-ozujak": {
    hr: "Alicante – Escapada de Primavera (ožujak)",
    en: "Alicante – Spring Escape (March)",
    de: "Alicante – Frühlingsausflug (März)",
    es: "Alicante – Escapada de Primavera (marzo)",
  },
  "madrid-segovia": {
    hr: "Madrid & Segovia – City Break",
    en: "Madrid & Segovia – City Break",
    de: "Madrid & Segovia – City Break",
    es: "Madrid & Segovia – City Break",
  },
  "madrid-lipanj-dva-termina": {
    hr: "MADRID & SEGOVIA & mogućnost izleta u TOLEDO",
    en: "MADRID & SEGOVIA & optional TOLEDO excursion",
    de: "MADRID & SEGOVIA & optionaler Ausflug nach TOLEDO",
    es: "MADRID & SEGOVIA & posibilidad de excursión a TOLEDO",
  },
  "od-madrida-do-vinograda": {
    hr: "Od Madrida do vinograda",
    en: "From Madrid to Vineyards",
    de: "Von Madrid zu den Weinbergen",
    es: "De Madrid a los viñedos",
  },
  "valladolid-1tjedan": {
    hr: "Valladolid učenje španjolskog jezika",
    en: "Valladolid – Spanish language course (August)",
    de: "Valladolid – Spanischkurs (August)",
    es: "Valladolid – curso de español (agosto)",
  },
  "valladolid-2tjedan": {
    hr: "Valladolid učenje španjolskog jezika",
    en: "Valladolid – Spanish language course (2 weeks, August)",
    de: "Valladolid – Spanischkurs (2 Wochen, August)",
    es: "Valladolid – curso de español (2 semanas, agosto)",
  },
  "valladolid-1tjedan-lipanj": {
    hr: "Valladolid učenje španjolskog jezika (13.–21. 6. 2026.)",
    en: "Valladolid – Spanish course (13–21 June 2026)",
    de: "Valladolid – Spanischkurs (13.–21. Juni 2026)",
    es: "Valladolid – curso de español (13–21 jun 2026)",
  },
  "valladolid-2tjedan-lipanj": {
    hr: "Valladolid učenje španjolskog jezika (13.–27. 6. 2026., 2 tjedna)",
    en: "Valladolid – Spanish course (13–27 June 2026, 2 weeks)",
    de: "Valladolid – Spanischkurs (13.–27. Juni 2026, 2 Wochen)",
    es: "Valladolid – curso de español (13–27 jun 2026, 2 semanas)",
  },
  valencia: {
    hr: "Valencia – Las Fallas (privatni aranžman)",
    en: "Valencia – Las Fallas (private arrangement)",
    de: "Valencia – Las Fallas (privates Arrangement)",
    es: "Valencia – Las Fallas (arreglo privado)",
  },
};

const TOUR_DESCRIPTIONS = {
  barcelona: {
    hr: "Kratki obilazak Barcelone i izlet na Costa Bravu uz opušten ritam.",
    en: "Short Barcelona stay with a relaxed Costa Brava escape.",
    de: "Kurzaufenthalt in Barcelona mit entspanntem Costa-Brava-Ausflug.",
    es: "Estancia en Barcelona y escapada relajada a la Costa Brava.",
  },
  mexico: {
    hr: "Spoj povijesti, ulične hrane i nekoliko dana odmora na plaži.",
    en: "A mix of history, street food and beach relaxation.",
    de: "Eine Mischung aus Geschichte, Streetfood und Strandentspannung.",
    es: "Mezcla de historia, comida callejera y relax en la playa.",
  },
  tuscany: {
    hr: "Vinarije, sela na brežuljcima i šareni gradići uz more.",
    en: "Wineries, hilltop villages and colorful seaside towns.",
    de: "Weingüter, Hügellandschaften und bunte Küstenorte.",
    es: "Bodegas, pueblos en colinas y pueblos costeros de colores.",
  },
  alicante: {
    hr: "Proljetni bijeg na Costa Blancu – vino, more i radionica paelle.",
    en: "Spring escape to the Costa Blanca – wine, sea and paella workshop.",
    de: "Frühlingsflucht an die Costa Blanca – Wein, Meer und Paella-Workshop.",
    es: "Escape primaveral a la Costa Blanca – vino, mar y taller de paella.",
  },
  "alicante-maj": {
    hr: "Proljetni bijeg 07.–10.05. – Ryanair, 690 €, min. 8 osoba.",
    en: "Spring escape 7–10 May – Ryanair, €690, min. 8 people.",
    de: "Frühlingsausflug 7.–10. Mai – Ryanair, 690 €, min. 8 Personen.",
    es: "Escapada 7–10 mayo – Ryanair, 690 €, mín. 8 personas.",
  },
  "alicante-ozujak": {
    hr: "Proljetni bijeg 07.–10.03. – Ryanair, 590 €, min. 8 osoba.",
    en: "Spring escape 7–10 March – Ryanair, €590, min. 8 people.",
    de: "Frühlingsausflug 7.–10. März – Ryanair, 590 €, min. 8 Personen.",
    es: "Escapada 7–10 marzo – Ryanair, 590 €, mín. 8 personas.",
  },
  "madrid-segovia": {
    hr: "Tapas, Rooftops & španjolska energija. Iberia, 760 €, 4 dana / 3 noćenja.",
    en: "Tapas, rooftops & Spanish energy. Iberia, €760, 4 days / 3 nights.",
    de: "Tapas, Rooftops & spanische Energie. Iberia, 760 €, 4 Tage / 3 Nächte.",
    es: "Tapas, rooftops y energía española. Iberia, 760 €, 4 días / 3 noches.",
  },
  "od-madrida-do-vinograda": {
    hr: "Fiesta San Lorenzo, Ribera del Duero i Segovia: 10.-15.09. ili 15.-20.10.2026.",
    en: "Fiesta San Lorenzo, Ribera del Duero and Segovia: 10-15 Sep or 15-20 Oct 2026.",
    de: "Fiesta San Lorenzo, Ribera del Duero und Segovia: 10.-15.09. oder 15.-20.10.2026.",
    es: "Fiesta San Lorenzo, Ribera del Duero y Segovia: 10-15 sep o 15-20 oct 2026.",
  },
  "valladolid-1tjedan": {
    hr: "CIJENA ARANŽMANA: 1.790 € po osobi · 9 dana / 8 noći · kolovoz 2026.",
    en: "PACKAGE PRICE: €1,790 per person · 9 days / 8 nights · August 2026.",
    de: "PAKETPREIS: 1.790 € pro Person · 9 Tage / 8 Nächte · August 2026.",
    es: "PRECIO DEL PAQUETE: 1.790 € por persona · 9 días / 8 noches · agosto 2026.",
  },
  "valladolid-2tjedan": {
    hr: "CIJENA ARANŽMANA: 2.490 € po osobi · 14 dana / 13 noći · kolovoz/rujan 2026.",
    en: "PACKAGE PRICE: €2,490 per person · 14 days / 13 nights · Aug/Sep 2026.",
    de: "PAKETPREIS: 2.490 € pro Person · 14 Tage / 13 Nächte · Aug./Sep. 2026.",
    es: "PRECIO DEL PAQUETE: 2.490 € por persona · 14 días / 13 noches · ago/sep 2026.",
  },
  "valladolid-1tjedan-lipanj": {
    hr: "13.–21. 6. 2026. · 9 dana / 8 noći · 1.790 € po osobi.",
    en: "13–21 June 2026 · 9 days / 8 nights · €1,790 per person.",
    de: "13.–21. Juni 2026 · 9 Tage / 8 Nächte · 1.790 € p. P.",
    es: "13–21 jun 2026 · 9 días / 8 noches · 1.790 € por persona.",
  },
  "valladolid-2tjedan-lipanj": {
    hr: "13.–27. 6. 2026. · 14 dana / 13 noći · 2.490 € po osobi (dva tjedna).",
    en: "13–27 June 2026 · 14 days / 13 nights · €2,490 per person (two weeks).",
    de: "13.–27. Juni 2026 · 14 Tage / 13 Nächte · 2.490 € p. P. (zwei Wochen).",
    es: "13–27 jun 2026 · 14 días / 13 noches · 2.490 € por persona (dos semanas).",
  },
  valencia: {
    hr: "Las Fallas, privatni luksuzni apartman, vodič. Popunjeno – privatno.",
    en: "Las Fallas, luxury private apartment, guide. Full – private.",
    de: "Las Fallas, Luxus-Privatapartment, Betreuung. Ausgebucht – privat.",
    es: "Las Fallas, apartamento privado de lujo, guía. Completo – privado.",
  },
};

/**
 * @param {object} tour
 * @param {string} base - 'hr' | 'en' | ...
 * @param {function} t - i18n t
 */
export function getTourCardCopy(tour, base, t) {
  const titleMap = TOUR_TITLES[tour.key];
  const title =
    titleMap?.[base] ||
    titleMap?.en ||
    (typeof tour.key === "string" ? tour.key.replace(/-/g, " ") : "") ||
    "Putovanje";
  const descMap = TOUR_DESCRIPTIONS[tour.key];
  const blogSnippet = tour.blogText?.[base] || tour.blogText?.en || "";
  const desc =
    descMap?.[base] ||
    descMap?.en ||
    (blogSnippet ? blogSnippet.slice(0, 220).trim() + (blogSnippet.length > 220 ? "…" : "") : "") ||
    t("tours.fallbackDescription", "Pogledajte detalje putovanja.");
  return { title, desc };
}
